export const GET_PAYROLLS = "GET_PAYROLLS";
export const GET_PAYROLL_BY_ID = "GET_PAYROLL_BY_ID";
export const UPDATE_PAYROLL = "UPDATE_PAYROLL";
export const DELETE_PAYROLL = "DELETE_PAYROLL";
export const CREATE_PAYROLL = "CREATE_PAYROLL";
export const GET_PAYROLL_STUDIO_SESSIONS = "GET_PAYROLL_STUDIO_SESSIONS";
export const GET_PAYROLL_PROJECTS = "GET_PAYROLL_PROJECTS";
